import Vue from 'vue';
export const visibilityTracker = Vue.extend({
    mounted() {
        this.trackVisiblity();
    },
    methods: {
        trackVisiblity() {
            const observer = new IntersectionObserver((entries) => {
                // isIntersecting is true when element and viewport are overlapping
                // isIntersecting is false when element and viewport don't overlap
                if (entries[0].isIntersecting === true) {
                    this.$emit('visible');
                }
                else {
                    this.$emit('invisible');
                }
            }, { threshold: [0] });
            observer.observe(this.$el);
        },
    },
});
